export default __webpack_public_path__ + "static/media/effect-2.deb1c274.mp3";